import React from 'react';
import classes from './ProductImage.module.css';

type Props = {
  images: { merchant_product_image_id: number; url: string }[];
};

const ProductImages: React.FC<Props> = ({ images }) => {
  const [selectedImageIdx, setSelectedImageIdx] = React.useState<number>(0);

  return (
    <div className={classes.container}>
      {images.length > 1 && (
        <div className={classes.verticalList}>
          {images.map((image, index) => (
            <div key={index} onClick={() => setSelectedImageIdx(index)}>
              <img
                src={image.url}
                alt={'small'}
                className={`${classes.smallImage} ${
                  selectedImageIdx === index ? classes.selectedImage : ''
                }`}
              />
            </div>
          ))}
        </div>
      )}

      {images[selectedImageIdx]?.url && (
        <img className={classes.largeImage} src={images[selectedImageIdx].url} alt={'large'} />
      )}
    </div>
  );
};

export { ProductImages };
